import { Task as ApiTask, TaskStatus as ApiTaskStatus } from '../../api/cases/tasks/Task';
import Task, { TaskStatuses, TaskStatus, ITask } from '../Task';

const statusMap = new Map<ApiTaskStatus, TaskStatus>([
  ['COMPLETED', TaskStatuses.COMPLETED],
  ['TO_DO', TaskStatuses.TO_DO],
  ['NOT_APPLICABLE', TaskStatuses.NOT_APPLICABLE],
]);

const mapTaskStatus = (apiTaskStatus: ApiTaskStatus): TaskStatus => {
  return statusMap.get(apiTaskStatus) as TaskStatus;
};

export const apiToDomain = (tasksFromApi: ApiTask[]): ITask[] => {
  return tasksFromApi.map((taskFromApi) => {
    return new Task(taskFromApi.id, taskFromApi.description, mapTaskStatus(taskFromApi.status));
  });
};
